import { PricingEntryPoint } from '@/shared/lib/pricingAttribution';

type DownloadPaywallPlanName = 'Business' | 'Creator Pro' | 'Creator';

// Video and audio downloads are included from Creator; SRT files and lip-sync start at Creator Pro.
export const getDownloadPaywallPlanNames = (pricingEntryPoint: PricingEntryPoint): DownloadPaywallPlanName[] =>
  pricingEntryPoint.includes('lipsync') || pricingEntryPoint.includes('srt')
    ? ['Creator Pro', 'Business']
    : ['Creator', 'Creator Pro', 'Business'];
